export const WARNING_TIME_THRESHOLD = 15 * 60; // 15 mins in seconds
